import { useQuery } from '@tanstack/react-query';
import { GET_INTEGRATION_CONNECTIONS } from '../documents';
import { IntegrationConnection, IntegrationWorkspaceVariables } from '../types';
import { integrationConnectionsCacheKey } from './cacheKeys';
import {
  integrationAuthError,
  useIntegrationAuthFetcher,
} from './useIntegrationAuthFetcher';

interface ConnectionsResponse {
  integrationAuth: { listConnections: IntegrationConnection[] } | null;
}

export const useIntegrationConnections = (
  workspaceId: string | undefined,
  enabled = true
) => {
  const fetcher = useIntegrationAuthFetcher<
    ConnectionsResponse,
    IntegrationWorkspaceVariables
  >(GET_INTEGRATION_CONNECTIONS);
  const query = useQuery({
    queryKey: integrationConnectionsCacheKey(workspaceId),
    enabled: enabled && !!workspaceId,
    retry: false,
    queryFn: async (): Promise<IntegrationConnection[]> => {
      if (!workspaceId || !enabled) return [];
      const data = await fetcher({ workspaceId });
      if (!data.integrationAuth) throw integrationAuthError();
      return data.integrationAuth.listConnections;
    },
  });
  return { ...query, connections: query.data ?? [] };
};
